module.exports = __webpack_public_path__ + "static/media/img-phone.6ada6bfb.png";